module.exports = __webpack_public_path__ + "images/emoji/barber.84859902fa31480364bd.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/barber.png
// module id = XeM6
// module chunks = 13